(() => {
  const SELECTOR = "[data-lob-fsb]";

  const formatMXN = (cents) =>
    (cents / 100).toLocaleString("es-MX", { style: "currency", currency: "MXN" });

  const getCart = async () => {
    const r = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    if (!r.ok) return null;
    return r.json();
  };

  const render = (root, totalCents) => {
    const threshold = parseInt(root.dataset.threshold, 10);
    if (!threshold) return;

    const textEl = root.querySelector("[data-lob-fsb-text]");
    const barEl = root.querySelector("[data-lob-fsb-bar]");

    const remaining = Math.max(threshold - totalCents, 0);
    const pct = Math.min((totalCents / threshold) * 100, 100);

    if (barEl) barEl.style.width = `${pct}%`;

    if (!textEl) return;

    if (remaining > 0) {
      textEl.textContent = `Estás a ${formatMXN(remaining)} de obtener ENVÍO GRATIS en tu pedido.`;
    } else {
      textEl.textContent = "¡Felicidades! Tienes ENVÍO GRATIS en tu pedido.";
    }
  };

  const refresh = async () => {
    const blocks = document.querySelectorAll(SELECTOR);
    if (!blocks.length) return;

    const cart = await getCart();
    if (!cart) return;

    blocks.forEach((b) => render(b, cart.total_price));
  };

  // Inicial
  document.addEventListener("DOMContentLoaded", refresh);

  // Se actualiza cuando el drawer cambia por AJAX (muy común en cart drawers modernos)
  const observeDrawer = () => {
    const drawer = document.querySelector(".cart-drawer");
    if (!drawer) return;

    const obs = new MutationObserver(() => refresh());
    obs.observe(drawer, { childList: true, subtree: true });
  };

  document.addEventListener("DOMContentLoaded", observeDrawer);

  // Fallback: clicks y cambios dentro del drawer (por si el theme no re-renderiza con MutationObserver)
  document.addEventListener("click", (e) => {
    if (e.target && e.target.closest(".cart-drawer")) setTimeout(refresh, 250);
  });
  document.addEventListener("change", (e) => {
    if (e.target && e.target.closest(".cart-drawer")) setTimeout(refresh, 250);
  });
})();
